import { createFileRoute } from "@tanstack/react-router";
import { Shell } from "@/components/control-tower/Layout";
import { PerspectiveHero } from "@/components/control-tower/PerspectiveHero";
import { EnergyEfficiencySection } from "@/components/control-tower/perspectives/EnergyEfficiencySection";

export const Route = createFileRoute("/energy-efficiency")({
  component: OptimizationPage,
});

// Energiatehokkuus — scope-adaptive: one building's autonomous loop vs. the shared
// kanta/salkku overview grammar (opportunity findings), same IA as the judgment lenses.
function OptimizationPage() {
  return (
    <Shell
      title="Energiatehokkuus"
      subtitle="Reseptit ja havainnot · autonominen silmukka"
    >
      <div className="space-y-6">
        <PerspectiveHero perspectiveId="energy-efficiency" />
        <EnergyEfficiencySection />
      </div>
    </Shell>
  );
}
